import type { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/utils';

/**
 * カスタマイズされたTableコンポーネント
 */
type CNTableProps = ComponentPropsWithRef<'table'>;

export const CNTable = ({ className, ref, ...props }: CNTableProps) => (
  <table
    ref={ref}
    className={cn('w-full caption-bottom border-collapse bg-white [table-layout:fixed]', className)}
    {...props}
  />
);
